var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMixer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M114.57,76.07c-15.08-20.24-43.72-24.42-63.97-9.34-1.23,.92-2.41,1.89-3.54,2.93-17.58,16.18-19,43.52-4.75,62.77l91.78,123-92.33,124.15c-14.23,19.25-13.11,46.59,4.74,62.77,18.63,17.04,47.54,15.75,64.58-2.88,1.03-1.13,2.01-2.31,2.92-3.53l128.89-173.24c3.07-4.25,3.07-9.98,0-14.23L114.57,76.07ZM470.24,379.58l-92.33-124.13,91.78-123c14.22-19.25,12.83-46.59-4.75-62.77-18.62-17.04-47.54-15.76-64.58,2.87-1.04,1.13-2.01,2.31-2.93,3.54l-128,172.12c-3.07,4.25-3.07,9.98,0,14.23l128.57,173.5c15.08,20.24,43.72,24.42,63.97,9.34,1.23-.92,2.41-1.89,3.54-2.93,17.84-16.18,18.96-43.52,4.73-62.77Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixer);
export default __webpack_public_path__ + "static/media/mixer.a1f26e98a8b75aaec8ddecc12e45b5ce.svg";
export { ForwardRef as ReactComponent };